export const ClearFilter = "Clear filter";
export const KeywordFilterBarItemPlaceholderText = "Filter by keywords";
